import React, { isValidElement, ReactElement } from 'react';
import { isMemo, isValidElementType } from 'react-is';

/**
 * Render children:
 * - if it's a valid element: return
 * - if it's a function|component: create element from it
 * - else return it
 * @param Element
 * @param props
 * @returns {ReactElement}
 */
export const renderChildren = (Element: any, props: { [key: string]: any } = {}): ReactElement | null => {
    const hasProps = Object.keys(props).length > 0;

    if (isValidElement(Element)) {
        if (hasProps) {
            return {
                ...(Element as any),
                props: {
                    ...((Element.props || {}) as any),
                    ...props,
                },
            };
        }

        return Element;
    }

    if (Element && typeof Element !== 'string' && (isMemo(Element) || isValidElementType(Element))) {
        return <Element {...(props || {})} />;
    }

    return Element as any;
};

/**
 *
 * @param children
 * @param rest
 * @constructor
 */
export const RenderChildren = ({ children, ...rest }) => {
    return renderChildren(children, rest);
};

RenderChildren.displayName = 'RenderChildren';
